export default __webpack_public_path__ + "static/media/ans8.e10e59a5.png";